import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getCompanies, getCompany, addCompany, deleteCompany, getCompanyHistory } from "@/api/companies";

export function useCompanies(params?: { search?: string; riskLevel?: string }) {
  return useQuery({
    queryKey: ["companies", params],
    queryFn: () => getCompanies(params),
    staleTime: 30_000,
  });
}

export function useCompany(id: number) {
  return useQuery({
    queryKey: ["company", id],
    queryFn: () => getCompany(id),
    enabled: id > 0,
  });
}

export function useAddCompany() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ cnpj, tags, notes }: { cnpj: string; tags?: string[]; notes?: string }) =>
      addCompany(cnpj, tags, notes),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["companies"] }),
  });
}

export function useDeleteCompany() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => deleteCompany(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["companies"] }),
  });
}

export function useCompanyHistory(id: number) {
  return useQuery({
    queryKey: ["company-history", id],
    queryFn: () => getCompanyHistory(id),
    enabled: id > 0,
  });
}
